(() => {
  if (customElements.get('al-home-video')) return;
  customElements.define('al-home-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.control = this.querySelector('[data-video-play]');
      if (!this.video || !this.control) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.video.defaultMuted = true;
      this.video.muted = true;
      this.video.playsInline = true;
      this.manual = false;
      this.control.hidden = false;
      this.control.addEventListener('click', () => { this.manual = true; this.start(); }, options);
      this.video.addEventListener('playing', () => { this.control.hidden = true; }, options);
      this.video.addEventListener('pause', () => { this.control.hidden = false; }, options);
      this.video.addEventListener('error', () => { this.control.hidden = false; }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else this.start();
      }, options);
      window.addEventListener('pageshow', () => this.start(), options);
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches && !this.manual) this.video.pause();
        else this.start();
      }, options);
      this.start();
    }
    start() {
      if (document.hidden || (this.reduced.matches && !this.manual)) return;
      // A user click can play in Low Power Mode; never loop rejected autoplay attempts.
      this.video.muted = true;
      if (this.manual) this.setAttribute('data-manual-play', '');
      const playing = this.video.play();
      playing?.catch(() => { if (this.isConnected) this.control.hidden = false; });
    }
    disconnectedCallback() { this.abort?.abort(); this.video?.pause(); }
  });
})();